import React, { useEffect, PureComponent } from 'react';
import { withTranslation, I18nextProvider, Translation } from 'react-i18next';
export { Trans } from 'react-i18next';
import i18n from './i18n.js';
import createHocName from './createHocName.js';
import 'i18next';
import './getDisplayName.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var withI18n = (Component, defaultLocaleResource, { forceRemount = true } = {}) => {
  const Translated = withTranslation(void 0, { withRef: true })(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    React.forwardRef((props, ref) => {
      return /* @__PURE__ */ React.createElement(Component, __spreadValues({ ref }, props));
    })
  );
  const _I18nWrapper = class extends PureComponent {
    constructor(props) {
      super(props);
      const { locale, localeResource } = props;
      this.i18n = i18n({ locale, localeResource });
      this.state = {
        key: `${_I18nWrapper.displayName}-${locale}`
      };
    }
    async componentDidMount() {
      const { locale } = this.props;
      if (locale !== "en") {
        try {
          const localeResource = await import(
            /* webpackChunkName: "ricos_viewer_messages_[request]" */
            `../../statics/viewer/locale/messages_${locale}.json`
          ).then((res) => res.default);
          this.changeLocale({ locale, localeResource });
        } catch (err) {
          console.warn(`can't find ${locale} locale`, err);
        }
      }
    }
    componentWillReceiveProps(nextProps) {
      if (this.props.locale !== nextProps.locale) {
        this.changeLocale(nextProps);
      }
    }
    changeLocale({ locale, localeResource }) {
      this.i18n.addResourceBundle(locale, "translation", localeResource);
      this.i18n.changeLanguage(locale, (err) => {
        if (!err) {
          if (forceRemount) {
            this.setState({ key: `${_I18nWrapper.displayName}-${this.i18n.language}` });
          } else {
            this.forceUpdate();
          }
        }
      });
    }
    render() {
      const _a = this.props, { forwardedRef } = _a, rest = __objRest(_a, ["forwardedRef"]);
      return /* @__PURE__ */ React.createElement(I18nextProvider, { i18n: this.i18n }, /* @__PURE__ */ React.createElement(Translated, __spreadValues({ key: this.state.key, ref: forwardedRef }, rest)));
    }
  };
  let I18nWrapper = _I18nWrapper;
  I18nWrapper.defaultProps = {
    locale: "en",
    localeResource: defaultLocaleResource
  };
  I18nWrapper.displayName = createHocName("I18nWrapper", Component);
  return React.forwardRef((props, ref) => /* @__PURE__ */ React.createElement(I18nWrapper, __spreadProps(__spreadValues({}, props), { forwardedRef: ref })));
};
const RicosTranslate = ({ children, locale, localeResource }) => {
  const [forceCounter, forceUpdate] = React.useState(0);
  const i18nInstance = React.useMemo(() => i18n({ locale, localeResource }), []);
  useEffect(() => {
    i18nInstance.addResourceBundle(locale, "translation", localeResource);
    i18nInstance.changeLanguage(locale, (err) => {
      if (!err) {
        forceUpdate(forceCounter + 1);
      }
    });
  }, [locale, localeResource]);
  return /* @__PURE__ */ React.createElement(I18nextProvider, { i18n: i18nInstance }, /* @__PURE__ */ React.createElement(Translation, { i18n: i18nInstance }, (t) => {
    return children(t);
  }));
};
const translate = withTranslation;

export { RicosTranslate, withI18n as default, translate };
//# sourceMappingURL=withI18n.js.map
